/**
 * Language switcher module
 *
 * 바깥 클릭·Esc·다른 메뉴와의 배타성은 공용 팝오버 등록부가 처리한다.
 */
import { openExclusive, closedExclusive } from './popover-registry.js';

export function toggleLangMenu() {
    const menu = document.getElementById('langMenu');
    if (!menu) return;

    if (menu.classList.contains('show')) {
        closeLangMenu();
    } else {
        openLangMenu();
    }
}

export function openLangMenu() {
    const menu = document.getElementById('langMenu');
    const toggle = document.querySelector('.lang-toggle');

    if (menu) menu.classList.add('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    openExclusive('language-menu', closeLangMenu, { roots: ['.language-switcher'] });
}

export function closeLangMenu() {
    closedExclusive('language-menu');
    const menu = document.getElementById('langMenu');
    const toggle = document.querySelector('.lang-toggle');

    if (menu) menu.classList.remove('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
}

export function selectLanguage(lang) {
    const langInput = document.getElementById('langInput');
    const langForm = document.getElementById('langForm');

    if (langInput && langForm) {
        langInput.value = lang;
        langForm.submit();
    }
}

// 예전에는 여기서 바깥 클릭·Esc 문서 리스너를 붙였다. 이제 그 둘은 팝오버 등록부의
// 캡처 리스너 한 벌이 처리하므로 (openLangMenu 참조) 여기서 할 일은 없다.
export function setupLanguageSwitcher() {}

// Make functions available globally for onclick handlers
window.toggleLangMenu = toggleLangMenu;
window.selectLanguage = selectLanguage;
